import * as React from "react";

import "./saveModal.scss";

import {cs}             from "@Common/react/chain-services";
import {keyed}          from "@Common/react/keyed";
import {TimeoutAction}  from "@Common/react/timeout-action";
import {UseState}       from "@Common/react/use-state";
import {ModalService3}  from "@Common/ui-components/modal-service-3/modal-service-3";
import {cache0}         from "@Common/utils/cache0";
import {chain}          from "@Common/utils/fs";

// Notify user to save after 30 minutes
export const SaveModal = ({onSave, changeAlertMessage, disabled, next: rootNext}) => cs(
    ["resetTimer", (_, next) => UseState({initValue: 0, next})],
    ["modal", ({resetTimer}, next) => ModalService3({
        width: 400,
        xToClose: false,
        ignorePassiveClose: true,
        rootNext: next,
        next: (mo) => SaveModalContent({
            changeAlertMessage,
            onSave,
            onCancel: () => {
                resetTimer.change(v => v + 1);
                mo.close();
            },
            modal: {
                close: mo.close,
            }
        }),
        header: {
            noBorder: true,
        },
    })],

    ({modal, resetTimer}) => <>
        {!disabled && cs(
            keyed(resetTimer.value),
            () => TimeoutAction({
                delay: chain(
                    getTimeoutDelay(),
                    (_) => !_ ? 30*60*1000 : +_,
                ),
                action: () => modal.show(),
            }),
        )}

        {rootNext()}
    </>,
);

const SaveModalContent = ({onSave, changeAlertMessage, onCancel, modal}) => cs(
    ["submitting", (_, next) => UseState({next})],
    ({submitting}) => (
        <div className="save-modal-box-f23">
            <div className="message">
                <p>It has been 30 minutes since you last saved your work.</p>
                <p>Would you like to Save your work now?</p>
            </div>

            <div className="footer">
                <button
                    className="save"
                    disabled={submitting.value}
                    onClick={async () => {
                        submitting.onChange(true);
                        changeAlertMessage(null);

                        const response = await onSave();
                        submitting.onChange(false);

                        if (response) {
                            changeAlertMessage({
                                heading: "CHANGES SAVED",
                                message: "All of your changes have been saved",
                                success: true,
                            });
                        } else {
                            changeAlertMessage({
                                heading: "SAVE INCOMPLETE",
                                message: "Saving has not been completed. Please check your internet connection and Save again",
                                success: false,
                            });
                        }

                        modal.close();
                    }}
                >
                    <i className="fa fa-check"/>{" "}SAVE
                </button>

                <button
                    className="close"
                    disabled={submitting.value}
                    onClick={() => {
                        changeAlertMessage({
                            heading: "CHANGES NOT SAVED",
                            message: "No changes were saved. Please click the “Save” button to save your work.",
                            success: false,
                        });
                        onCancel();
                    }}
                >
                    <i className="fa fa-times"/>{" "}CLOSE
                </button>
            </div>
        </div>
    ),
);
const getTimeoutDelay = cache0(() => sessionStorage.getItem('sessionModalTimer'));

